import { render, staticRenderFns } from "./odetail.vue?vue&type=template&id=188ded01&scoped=true"
import script from "./odetail.vue?vue&type=script&lang=js"
export * from "./odetail.vue?vue&type=script&lang=js"
import style0 from "./odetail.vue?vue&type=style&index=0&id=188ded01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188ded01",
  null
  
)

export default component.exports